import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../custom/BackButton';
import { createdUpdatedInfo, formatMawb } from '../../../utils';
import ActionIcon from '../../custom/ActionIcon';
import { UniqueAwb } from './Customs';
import CustomSwitch from '../../custom/CustomSwitch';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    selectedItem: UniqueAwb | null;
    manageCustomsHold: (b_customs_hold: boolean) => Promise<void>;
}

export default function CustomsModal ({
    modal,
    setModal,
    selectedItem,
    manageCustomsHold
}: Props) {

    const [hold, setHold] = useState<boolean>(true);

    useEffect(() => {
        if (!selectedItem) return;
        setHold(selectedItem.customsHold);
    }, [selectedItem]);

    const toggle = () => setModal(!modal);

    if (!selectedItem) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Manage {selectedItem.numLocations} locations for AWB: {formatMawb(selectedItem.s_mawb)}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <CustomSwitch 
                    label={`Customs Hold ${hold ? 'ON' : 'OFF'}`}
                    value={hold}
                    handleSwitch={() => setHold(prev => !prev)}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon type={'save'} onClick={() => manageCustomsHold(hold)} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;